import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import Nav from '../components/admin/NavAdmin';
import PrimaryButton from '../components/shared/PrimaryButton';
import SecondaryButton from '../components/shared/SecondaryButton';
import usePageMeta from "../util/shared/usePageMeta";

const NotFound = () => {
   usePageMeta({ title: "Pagina niet gevonden · Resto-Online", noindex: true });
  const navigate = useNavigate();

  return (
    <>
      <Nav />
      <div className="flex min-h-[70vh] flex-col items-center justify-center px-10 py-16 text-center">
        <p className="font-display text-7xl font-bold tracking-tight text-blue-600 sm:text-8xl">404</p>
        <h1 className="mt-4 font-display text-[22px] font-bold text-gray-950 sm:text-[26px] md:text-[30px]">
          Pagina niet gevonden
        </h1>
        <p className="mt-2 max-w-md text-gray-500">
          Sorry, de pagina die je probeert te bezoeken bestaat niet of is verplaatst.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <SecondaryButton onClick={() => navigate(-1)}>
            <ArrowLeft size={16} /> Ga terug
          </SecondaryButton>
          <PrimaryButton onClick={() => (window.location.href = '/')}>
            <Home size={16} /> Ga naar homepagina
          </PrimaryButton>
        </div>
        <p className="mt-10 text-sm text-gray-500">
          Heb je hulp nodig?{' '}
          <a href="mailto:info@resto-online.be" className="font-semibold text-blue-600 hover:underline">
            Neem contact met ons op
          </a>
        </p>
      </div>
    </>
  );
};

export default NotFound;
